export default {
  viewBox: "0 0 24 24",
  html: "<defs><path id=\"a\" d=\"M0 0h50v50H0z\"/></defs><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M16.59 5.5 12 10.08 7.41 5.5 6 6.91l6 6 5.999-5.999v-.002z\"/><path d=\"M12 15.08 7.41 10.5 6 11.91l6 6.001 5.999-6v-.002L16.59 10.5z\"/><use xlink:href=\"#a\" fill=\"#000\" transform=\"translate(-13 -13)\"/></g>"
};